import { VNode, VueConstructor } from 'vue';
import i18n from '../../locales/i18n';
import { iconClassEnum } from '../../enums/iconClassEnum';

export type ToastVariant = 'primary' | 'error';

const plugin = {
  install(vueApp: VueConstructor) {
    vueApp.prototype.$confirmAction = function (message: VNode[] | string): Promise<boolean | null> {
      if (!this.$bvModal) {
        return Promise.resolve(false);
      }

      const iconClose = `<i class="${iconClassEnum.CLOSE}"></i>`;

      return this.$bvModal.msgBoxConfirm(message, {
        size: 'sm',
        modalClass: 'modal-warning',
        okVariant: 'primary',
        cancelVariant: 'link',
        title: i18n.t('label.warning'),
        okTitle: i18n.t('button.yes'),
        cancelTitle: i18n.t('button.cancel'),
        hideHeaderClose: false,
        headerCloseContent: iconClose,
      });
    };
    vueApp.prototype.$showToast = function (message: VNode[] | string, variant: ToastVariant = 'primary'): void {
      if (!this.$root?.$bvToast) {
        return;
      }

      this.$root.$bvToast.toast(message, {
        solid: true,
        autoHideDelay: 3000,
        variant,
      });
    };
  },
};
export default plugin;
